import { FieldErrorMessage } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/FormControlErrorMessage";
import { ComponentProps } from "react";
import { FieldError, FieldErrors, FieldValues } from "react-hook-form";
import { Field } from "shared/components/Spor";
import { getFieldFromNestedObject } from "shared/utils/objectUtils";

export const RenderErrorInPath = ({
  errors,
  errorPath,
  ...rest
}: {
  errors?: FieldErrors<FieldValues>;
  errorPath: string;
} & ComponentProps<typeof Field>) => {
  const field = getFieldFromNestedObject<FieldError>(errors, errorPath);
  if (!field) {
    return null;
  }

  return <FieldErrorMessage {...rest} field={field} />;
};
